
function uuid () {
    var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now();
    }
    return 'xxyy-4xxx-yxxx-xx-sc'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}
function setTabIndex (dom) {
    const index = dom.getAttribute('tabindex');
    if (!index) {
        dom.setAttribute('tabindex', -1);
        return true;
    }
    return false;
}
function debounce (func, wait, immediate) {
    var timer;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timer = null;
            if (!immediate) {
                func.apply(context, args);
            }
        }
        var callNow = immediate && !timer;
        clearTimeout(timer);
        timer = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    }
}
const onTargetMousedown = debounce((target, eventObject) => {
    if (!eventObject) return ;
    Object.values(eventObject).forEach(item => {
        const target = item.target;
        const index = target.getAttribute('tabindex');
        if (index === '-1') {
            target.removeAttribute('tabindex');
        }
    })
    setTabIndex(target);
}, 500, true)
class Shortcut {
    static getInstance(){
        if (window.Shortcut) {
            return window.Shortcut;
        }
        return window.Shortcut = new Shortcut();
    }
    constructor(){
        this.eventObject = {};
        this._addKeyEvent();
    }
    setDebugger (boolean) {
        this.debugger = boolean;
    }
    _cwarn () {
        if (!this.debugger) return ;
        return console.warn.apply(this, arguments);
    }
    _addTabindexEvent (target) {
        if (target._hasmousedownevent_) return ;
        const _mousedown_ = target._mousedown_ = e => {
            onTargetMousedown(target, this.eventObject)
        }
        target.addEventListener('mousedown', _mousedown_);
        target._hasmousedownevent_ = true;
    }
    _addEventObject (target, keys, callback) {
        if (!keys) throw Error('keys arguments is required.');
        const stctid = target._stctid || uuid();
        keys = (keys + '').toLocaleLowerCase().replace(/ /g, '');
        // 自动添加tabindex属性，用于确保触发键盘事件
        this._addTabindexEvent(target);
        let value = this.eventObject[stctid];
        if (!value) value = {};
        value.target = value.target || target;
        if (value[keys]) {
            this._cwarn('重复绑定快捷键：', target, keys);
        }
        value[keys] = callback;
        target._stctid = stctid;
        this.eventObject[stctid] = value;
    }
    _addKeyEvent () {
        let keyList = [];
        let keyCodeList = [];
        const getCurrentActiveElement = () => {
            let activeElement = document.activeElement;
            const isTextElement = ['INPUT', 'TEXTAREA'].includes(activeElement.nodeName) || activeElement.hasAttribute('contenteditable');
            if (isTextElement || activeElement.hasAttribute('tabindex')) return activeElement;
            const ret = Object.values(this.eventObject).find(item => {
                return item.target.hasAttribute('tabindex')
            });
            return ret && ret.target;
        }
        const checkEvent = (e, parentNode) => {
            const target = parentNode || e.target;
            const stctid = target._stctid;
            const eventObject = this.eventObject;
            const value = eventObject[stctid];
            parentNode = target.parentNode;
            if (stctid && value) {
                let _keyList = keyList.concat([]);
                let _keyCodeList = keyCodeList.concat([]);
                do {
                    const keyListStr = _keyList.join('+');
                    const keyCodeListStr = _keyCodeList.join('+');
                    const keyCallback = value[keyListStr];
                    const keyCodeCallback = value[keyCodeListStr];
                    if (keyCallback || keyCodeCallback) {
                        keyList = _keyList;
                        keyCodeList = _keyCodeList;
                        (keyCallback || keyCodeCallback)(e);
                        return ;
                    } else {
                        _keyList.shift();
                        _keyCodeList.shift();
                    }
                } while (_keyList.length + _keyCodeList.length);
            }
            if ((parentNode && parentNode.nodeName !== 'HTML')) {
                checkEvent(e, parentNode);
            }
        }
        document.addEventListener('keydown', e => {
            let { key, keyCode } = e;
            key = key === 'Control' ? 'ctrl' : 
                key === 'Escape' ? 'esc' : 
                key.toLocaleLowerCase();
            const keyIndex = keyList.indexOf(key);
            const keyCodeIndex = keyCodeList.indexOf(keyCode);
            if (keyIndex > -1) keyList.splice(keyIndex, 1);
            if (keyCodeIndex > -1) keyCodeList.splice(keyCodeIndex, 1);
            keyList.push(key);
            keyCodeList.push(keyCode);
            // if (keyCode === 65) {
            //     debugger
            // }
            const target = getCurrentActiveElement();
            checkEvent(e, target);
        });
        document.addEventListener('keyup', e => {
            let { keyCode, altKey, ctrlKey, metaKey, shiftKey } = e;
            if (!altKey && !ctrlKey && !metaKey && !shiftKey) {
                keyList = [];
                keyCodeList = [];
            } else {
                const index = keyCodeList.indexOf(keyCode);
                if (index > -1) {
                    keyList.splice(index, 1);
                    keyCodeList.splice(index, 1);
                }
            }
        });
    }
    register (target, keys, callback) {
        if (!target) target = document;
        if (target instanceof Node) {
            if (keys instanceof Array) {
                keys.forEach(key => {
                    this._addEventObject(target, key, callback);    
                });
            } else {
                this._addEventObject(target, keys, callback);
            }
        } else {
            throw Error('first arguments is not a node.');
        }
        return this;
    }
    unregister (target) {
        const _stctid = target._stctid;
        target.removeEventListener('mousedown', target._mousedown_);
        delete this.eventObject[_stctid]
        delete target._stctid;
        delete target._hasmousedownevent_;
        delete target._mousedown_;
    }
}
export default Shortcut.getInstance()